class VanillaAccordion {
  constructor(
    boxSelector,
    triggerSelector,
    contentSelector,
    { closeOthers = false } = {},
  ) {
    this.units = Array.from(document.querySelectorAll(boxSelector))
      .map((box) => ({
        box,
        trigger: box.querySelector(triggerSelector),
        content: box.querySelector(contentSelector),
      }))
      .filter((u) => u.trigger && u.content);

    this.closeOthers = closeOthers;
    if (!this.units.length) return;

    this.onClick = this.onClick.bind(this);
    this.onResize = this._debounce(this.onResize.bind(this), 100);

    // 初期化
    this.units.forEach((unit) => {
      const { box, trigger, content } = unit;

      content.style.overflow = "hidden";

      // js-active が付いているものは初期表示で開く
      if (box.classList.contains("js-active")) {
        content.style.height = "auto";
      } else {
        content.style.height = "0px";
      }

      trigger.addEventListener("click", this.onClick);
    });

    window.addEventListener("resize", this.onResize, { passive: true });
  }

  onClick(e) {
    if (e.currentTarget.tagName === "A") e.preventDefault();

    const unit = this.units.find((u) => u.trigger === e.currentTarget);
    if (!unit) return;

    const isOpen = unit.box.classList.contains("js-active");
    if (isOpen) this._close(unit);
    else this._open(unit);
  }

  _open(unit) {
    const { box, content } = unit;

    if (this.closeOthers) {
      this.units.forEach((u) => {
        if (u !== unit) this._close(u);
      });
    }

    box.classList.add("js-active");

    const start =
      getComputedStyle(content).height === "auto"
        ? content.scrollHeight
        : content.getBoundingClientRect().height;

    content.style.height = `${start}px`;

    requestAnimationFrame(() => {
      content.style.height = `${content.scrollHeight}px`;
    });

    const onEnd = (ev) => {
      if (ev.propertyName !== "height") return;
      content.style.height = "auto";
      content.removeEventListener("transitionend", onEnd);
    };
    content.addEventListener("transitionend", onEnd, { once: true });
  }

  _close(unit) {
    const { box, content } = unit;
    const h = getComputedStyle(content).height;

    if (h === "0px") {
      box.classList.remove("js-active");
      return;
    }

    // auto の場合も実高さを取得してから閉じる
    content.style.height = `${content.scrollHeight}px`;
    box.classList.remove("js-active");

    requestAnimationFrame(() => {
      content.style.height = "0px";
    });
  }

  onResize() {
    this.units.forEach(({ box, content }) => {
      if (box.classList.contains("js-active")) {
        content.style.height = "auto";
      }
    });
  }

  _debounce(fn, ms) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), ms);
    };
  }
}

export default VanillaAccordion;
